import { useSyncExternalStore } from 'react'

import { serverTimeOffsetMs, subscribeServerTimeOffset } from '~/models/clock'

/**
 * 現在の server time offset (ms) を購読する hook。
 *
 * offset は session RPC (`useCurrentSession`) 完了時に確定するため、 初回描画済みの
 * 時計消費者は自力では偽装時刻へ揃わない。 この hook を「現在時刻を state / タイマー
 * として保持する側」 の依存に含めることで、 offset 到着時に再描画とタイマー再予約が
 * 走る。
 *
 * offset が変わらない環境 (= 偽装なし・時計ズレなし) では通知が飛ばないため、 再描画は
 * 増えない。
 */
export const useServerTimeOffsetMs = (): number =>
  useSyncExternalStore(
    subscribeServerTimeOffset,
    serverTimeOffsetMs,
    serverTimeOffsetMs,
  )
